import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Dashboard } from '@/components/Dashboard';
import { Login } from '@/components/Login';
import { Onboarding } from '@/components/onboarding/Onboarding';
import { Spinner } from '@/components/ui/Spinner';
import { authQueryOptions, profileQueryOptions } from '@/lib/api';
import { DashboardProvider } from '@/providers/dashboard/DashboardProvider';

export const Route = createFileRoute('/')({ component: IndexPage });

const CenterSpinner = () => (
  <div className="flex min-h-screen items-center justify-center">
    <Spinner />
  </div>
);

function IndexPage() {
  const queryClient = useQueryClient();
  const [replayingOnboarding, setReplayingOnboarding] = useState(false);

  const { data: authStatus, isLoading: isCheckingAuth } = useQuery(
    authQueryOptions(),
  );

  const isAuthed = Boolean(authStatus);
  const { data: profileData, isLoading: isLoadingProfile } = useQuery({
    ...profileQueryOptions(),
    enabled: isAuthed,
  });

  if (isCheckingAuth) {
    return <CenterSpinner />;
  }

  if (!isAuthed) {
    return (
      <Login
        onSuccess={() =>
          queryClient.invalidateQueries({
            queryKey: authQueryOptions().queryKey,
          })
        }
      />
    );
  }

  if (isLoadingProfile) {
    return <CenterSpinner />;
  }

  if (!profileData?.profile || replayingOnboarding) {
    return (
      <Onboarding
        onComplete={() => {
          setReplayingOnboarding(false);
          queryClient.invalidateQueries({ queryKey: ['profile'] });
        }}
      />
    );
  }

  return (
    <DashboardProvider>
      <Dashboard onReplayOnboarding={() => setReplayingOnboarding(true)} />
    </DashboardProvider>
  );
}
